//./plugins/posthog.js
import posthog from "posthog-js";

export default {
  install(Vue) {
    Vue.prototype.$posthog = posthog.init(
      "phc_EEBVrWHfIQXHog5yYVub920mRwqW82a0dtlb1arbgFv",
      {
        api_host: "https://us.i.posthog.com",
        person_profiles: 'identified_only',
      }
    );
  }
};